export const PER_LOAD = 5
export const PER_LOAD_ALL = 999

